export default {
  getCountryAlpha2: (state) => (countryCode) => {
    if(countryCode) {
      let cc = state.countryCodes.filter(
        country => country.id === countryCode
      );
      return cc.length > 0 ? cc[0].alpha2.toLowerCase() : null;
    }else{
      return null
    }
  },
  getVesselsWithLabel: (state) => {
    return state.vessels.map(vessel => {
      vessel.label = vessel.name_ja || vessel.name;
      return vessel;
    });
  }
}
